// The race's own code (its rule set, the race rings and the phone's keke prediction) is loaded only
// when a race is near: a phone that never races never carries it. Loading it registers the race
// rules and the rings with the simulation and the maps.
type Race = typeof import('@wahala/simulation/race');

let kit: Race | null = null;
let loading: Promise<Race> | null = null;

/** The race module once loaded, or null before. */
export const raceKit = (): Race | null => kit;

/** Load the race module (once). */
export function loadRace(): Promise<Race> {
  loading ??= import('@wahala/simulation/race').then((m) => {
    kit = m;
    return m;
  });
  return loading;
}
